/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import ImageContent from "@/components/molecules/policy-document-section/header-banner/image-content";
import ThankYouContent from "@/components/molecules/policy-document-section/header-banner/thank-you-content";
import { ImageBannerProps } from "@/types/policy-document-types";

function HeaderBanner({
  havDoc,
  ...props
}: ImageBannerProps & { havDoc: boolean }) {
  return (
    <div
      className="grid lg:grid-cols-12 lg:col-span-12 lg:order-1 gap-spacing-m md:gap-spacing-l"
      data-testid="headerBanner-testid"
    >
      <div className="relative overflow-hidden h-[88px] md:h-[120px] lg:h-full rounded-radius-xxl lg:col-span-5 lg:order-2">
        <ImageContent {...props} />
      </div>
      <div className="bg-dark-surface-accent-1-primary text-text-body lg:text-dark-text-title rounded-radius-xxl p-spacing-l md:p-spacing-xl font-body-font lg:col-span-7 lg:order-1">
        <ThankYouContent {...props} havDoc={havDoc} />
      </div>
    </div>
  );
}

export default HeaderBanner;
